import React, { useState, useEffect, useRef } from "react";
import useTheme from "../../ColorConfig/usetheme";

const RollingCounter = ({
  targetCount,
  duration = 6000,
  delay = 0,
  shouldAnimate = false,
}) => {
  const [count, setCount] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const animationRef = useRef(null);
  const colors = useTheme();

  const animateCounter = () => {
    if (targetCount <= 0) return;

    setIsAnimating(true);
    const startTime = Date.now();
    const startValue = 0;
    const endValue = targetCount;

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = Math.floor(startValue + (endValue - startValue) * easeOutQuart);
      
      setCount(currentCount);

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        setIsAnimating(false);
      }
    };

    setTimeout(() => {
      animate();
    }, delay);
  };

  useEffect(() => {
    if (shouldAnimate) {
      animateCounter();
    } else {
      setCount(targetCount);
    }
  }, [shouldAnimate, targetCount]);

  useEffect(() => {
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <div className="rolling-counter">
      <span className={`counter-number ${isAnimating ? "counting" : ""}`}>
        {count}
      </span>
      <span className="plus">+</span>
    </div>
  );
};

export default RollingCounter;